import { ApplicationController } from "../application_controller";

export default class extends ApplicationController {
  static targets = ["tbody"];

  async addNewRefund(event) {
    event.preventDefault();
    const parent = event.currentTarget.closest('table');
    const url = event.currentTarget.dataset.url;
    const ticketId = event.currentTarget.dataset.ticketId;
    const refundsRow = parent.querySelector(`#refunds_${ticketId}`);

    refundsRow.style.display = '';
    
    const response = await fetch(`${url}.json`, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    });

    const responseText = await response.text();
    const html = JSON.parse(responseText).html;
    const tbody = refundsRow.querySelector('tbody');
    
    tbody.insertAdjacentHTML('beforeend', html)
    
    const lastRow = tbody.querySelector('tr:last-child');
    if (lastRow) {
      const countInput = lastRow.querySelector('input[name*="[tickets_count]"]');
      if (countInput) {
        countInput.focus();
      }
    }

    this.recalculateRefundIndex(tbody)
  }

  recalculateRefundIndex(tbody) {
    const rows = tbody.querySelectorAll('tr')
    rows.forEach((row, index) => {
      const numberCell = row.querySelector('td:first-child')
      if (numberCell) {
        numberCell.textContent = index + 1
      }
    })
  }

  async removeRefund(event) {
    event.preventDefault();
    const confirmMessage = event.currentTarget.dataset.confirmMessage;
    
    if (!confirm(confirmMessage)) {
      return;
    }
    
    const row = event.currentTarget.closest('tr');
    const tbody = row.closest('tbody');
    const refundsRow = row.closest('tr.ticket-refunds');
    
    const idInput = row.querySelector('input[name*="[id]"]');
    
    if (idInput) {
      const idName = idInput.getAttribute('name');
      const destroyName = idName.replace('[id]', '[_destroy]');
      const idValue = idInput.value;
      
      const destroyInput = document.createElement('input');
      destroyInput.setAttribute('type', 'hidden');
      destroyInput.setAttribute('name', destroyName);
      destroyInput.setAttribute('value', 'true');
      
      const hiddenIdInput = document.createElement('input');
      hiddenIdInput.setAttribute('type', 'hidden');
      hiddenIdInput.setAttribute('name', idName);
      hiddenIdInput.setAttribute('value', idValue);
      
      const form = row.closest('form');
      if (form) {
        form.appendChild(destroyInput);
        form.appendChild(hiddenIdInput);
      }
    }
    
    row.remove();

    this.recalculateRefundIndex(tbody);

    if (!tbody.querySelector('tr')) {
      if (refundsRow) {
        refundsRow.style.display = 'none';
      }
    }
  }
}